import VanAssumptionsPage from './VanAssumptionsPage';

export default VanAssumptionsPage;
